/** "122 MB", "510 KB": download sizes as the picker shows them. */
export function formatDownloadSize(bytes: number): string {
  if (bytes >= 1_000_000) {
    return `${Math.round(bytes / 1_000_000)} MB`;
  }
  return `${Math.max(1, Math.round(bytes / 1000))} KB`;
}
